export const iconFontAwesomeCodingCode = (
	<i className="fa-solid fa-code"></i>
);
